<template>
  <div class="ibox theme">
    <div class="ibox-title">
      <h2>{{ $t('cms.site.theme.title') }}</h2>
    </div>
    <div :class="'ibox-content p-md' + (listLoading ? ' sk-loading' : '')">

      <div v-if="listLoading" class="sk-spinner sk-spinner-double-bounce">
          <div class="sk-double-bounce1"></div>
          <div class="sk-double-bounce2"></div>
      </div>

      <!-- LogoAndBanner></LogoAndBanner> -->
      
      <CssVariables></CssVariables>
    
    </div>
  </div>
</template>

<style>

</style>



<script lang="ts">
import { Ref, defineComponent, PropType, computed, onMounted, onBeforeUnmount, ref, watch, reactive } from '@fwk-node-modules/vue'
import { getApp, useRouter, useStore } from '@fwk-client/utils/vue-3-migration';

import LogoAndBanner from './forms/LogoAndBanner.vue';
import CssVariables from './forms/CssVariables.vue';

export default defineComponent({
    props: {
        
    },
    components: {
      // LogoAndBanner,
      CssVariables
    },
    setup(props, context) {
      const app = getApp();
      const $router = useRouter();
      const $store = useStore();

      const listLoading:Ref<boolean> = ref(false);

      return { 
        listLoading
      }
    }
})
</script>